import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const ScrollToAnchor = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const target = location.state && location.state.goto ? location.state.goto : (location.hash ? location.hash.replace('#', '') : null);
    if (!target) return;
    const run = () => {
      const el = document.getElementById(target);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        navigate(location.pathname, { replace: true, state: {} });
      }
    };
    const id = setTimeout(run, 50);
    return () => clearTimeout(id);
  }, [location, navigate]);
  return null;
};
